// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Creditor } from './creditor';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CreditorDatum extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  creditorId!: number;
  data?: string;
  docData?: string;
  eventFlags?: number;
  eventResponseFlags?: number;
  eventUid?: string;
  portalTs!: string;
  creditor!: Creditor;
}

